import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { CustoRecursoService } from 'src/app/services/custo-recurso.service';
import { toFormatValue } from 'src/app/shared/util/toFormatValue';
import Swal from 'sweetalert2';
import { BaseFormComponent } from '../../base-form/base-form.component';
import { CustoRecurso } from './custo-recurso';
import { ICustoRecursoPlanejamentoModel } from 'src/app/models/custo-recurso-planejamento.model';
import { CustoRecursoPlanejamentoService } from 'src/app/services/custo-recurso-planejamento.service';

@Component({
  selector: 'app-custos-recursos-outros-form-modal',
  templateUrl: './custos-recursos-outros-form-modal.component.html',
  styleUrls: ['./custos-recursos-outros-form-modal.component.scss']
})
export class CustosRecursosOutrosFormModalComponent extends BaseFormComponent implements OnInit {
  public modelCustoRecursoPlanejamento!: any;
  public tipoTrabalho: string;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private dialogRef: MatDialogRef<CustosRecursosOutrosFormModalComponent>,
    public matDialog: MatDialog,
    private custoRecursoService: CustoRecursoService,
    private custoRecursoPlanejamentoService: CustoRecursoPlanejamentoService,
    @Inject(MAT_DIALOG_DATA) private data) {
    super(route, toastr, router, localeService, matDialog);
    this.modelCustoRecursoPlanejamento = this.data;
  }

  ngOnInit(): void {
    if (this.data.id > 0) {
      this.titulo = 'Edição Custo e Recurso'
    }
    else {
      this.titulo = 'Inclusão Custo e Recurso'
    }

    if (this.router.url.includes("planejamento")) {
      this.tipoTrabalho = 'planejamento';
    }
    if (this.router.url.includes("osa")) {
      this.tipoTrabalho = 'osa';
    }
  }

  formatarInput(value) {
    return toFormatValue(value);
  }


  public async exibirModalCustoRecurso() {
    try {
      const res = await this.custoRecursoService.obter('', true);
      if (res.sucesso) {
        const dadosFiltrados = res.dados.filter(constatacao => constatacao.ativo);
        const modal = this.exibirModal('Selecionar custo e recurso ', dadosFiltrados, true, null, null, null, 'modal-component-custos-recursos');
        modal.afterClosed().subscribe(data => {
          if (data) {
            // this.modelCustoRecursoPlanejamento.id = data.id;
            this.modelCustoRecursoPlanejamento.nome = data.nome;
            this.modelCustoRecursoPlanejamento.valorUnitario = data.valorMedio;
          }
        }
        );
      } else {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  onInputValor(event: any): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value;

    // Permite apenas números (remove tudo que não é número)
    const numerosSomente = valor.replace(/\D/g, '');

    if (numerosSomente === '') {
      this.modelCustoRecursoPlanejamento.valorUnitario = 0;
      input.value = '';
      return;
    }

    const float = parseFloat(numerosSomente) / 100;
    this.modelCustoRecursoPlanejamento.valorUnitario = float;
    input.value = this.formatarValorVisual(float);
  }

  ajustarVisualizacao(): void {
    // Força ajuste ao sair do campo
    if (isNaN(this.modelCustoRecursoPlanejamento.valorUnitario)) {
      this.modelCustoRecursoPlanejamento.valorUnitario = 0;
    }
  }

  formatarValorVisual(valor: number): string {
    if (valor == null || isNaN(valor)) {
      return '';
    }

    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    });
  }

  public salvar(fechar: boolean) {
    if (this.modelCustoRecursoPlanejamento) {
      const dados = this.modelCustoRecursoPlanejamento

      const request$ = dados.id && dados.id > 0
        ? this.custoRecursoPlanejamentoService.atualizar(dados, this.tipoTrabalho)
        : this.custoRecursoPlanejamentoService.inserir(dados, this.tipoTrabalho)

      request$.subscribe({
        next: (res) => {
          if (res.sucesso) {
            this.modelCustoRecursoPlanejamento = res.dados;
            this.toastr.success('Registro salvo com sucesso!');
            if (fechar) {
              this.dialogRef.close(true);
            }
          } else {
            this.exibirMensagemErro(res.mensagem?.descricao || 'Erro ao salvar');
          }
        },
        error: (err) => this.exibirMensagemErro(err)
      });
    }
  }

  public cancelar() {
    this.dialogRef.close(true);
  }
}
